export const statisticsRoutes = [
  {
    path: '/statistics/monthly-storage-charge',
    component: () => import('modules/statistics/monthly-storage-charge/monthly-storage-charge'),
    meta: { name: '月度仓储费', keepAlive: true, permission: 'storageFee:view' ,modal:'分析'}
  },
  {
    path: '/statistics/shop-wide-analysis',
    component: () => import('modules/statistics/shop-wide-analysis/shop-wide-analysis'),
    meta: { name: '全店铺看板', keepAlive: true, permission: 'allStoreDashboard:view' ,modal:'分析'}
  },
  // {
  //   name: 'listingAnalysis',
  //   path: '/statistics/listing-analysis',
  //   component: () => import('modules/statistics/common/analysis/listing/listing-analysis-performence'),
  //   meta: { name: '商品表现', keepAlive: true, permission: 'listingAnalyze:view' }
  // },
  // {
  //   name: 'listingAnalysis',
  //   path: '/statistics/listing-analysis',
  //   component: () => import('modules/statistics/listing-analysis-copy/listing-analysis-copy'),
  //   meta: { name: '商品表现', keepAlive: true, permission: 'listingAnalyze:view', modal: '分析' }
  // },

  {
    name: 'listingAnalysis',
    path: '/statistics/listing-analysis',
    component: () => import('modules/statistics/listing-analysis-new/listing-analysis-new'),
    // component: () => import('modules/statistics/listing-analysis-new/goods-analysis/listing-analysis-goods'),
    // meta: { name: '销售表现', keepAlive: true, permission: 'listingAnalyze:view', modal: '分析' }
    meta: { name: '销售表现', keepAlive: true, permission: ['listingAnalyze:view', 'storeAnalyze:view'], condition: 'some',  modal: '分析' }
  },


  // {
  //   name: 'listingStatistics',
  //   path: '/statistics/listing-statistics',
  //   component: () => import('modules/statistics/listing-statistics/listing-statistics'),
  //   props: (route) => ({
  //     startDate: route.query.startDate,
  //     endDate: route.query.endDate,
  //   }),
  //   meta: { name: '商品统计', keepAlive: true, permission: 'listingStatistics:view' }
  // },
  {
    name: 'listingStatistics',
    path: '/statistics/listing-statistics',
    // component: () => import('modules/statistics/listing-statistics-copy/listing-statistics-copy'),
    component: () => import('modules/statistics/listing-statistics-new/listing-statistics-new'),
    props: (route) => ({
      startDate: route.query.startDate,
      endDate: route.query.endDate,
    }),
    meta: { name: '销售统计', keepAlive: true, permission: ['listingStatistics:view', 'storeStatistics:view'], condition: 'some', modal:'分析'}
  },
  // {
  //   name: 'productAnalysis',
  //   path: '/statistics/product-analysis',
  //   component: () => import('modules/statistics/common/analysis/product/product-analysis-performance'),
  //   meta: { name: '产品表现', keepAlive: true, permission: 'skuAnalyze:view' }
  // },
  {
    name: 'productAnalysis',
    path: '/statistics/product-analysis',
    component: () => import('modules/statistics/product-analysis-copy/product-analysis-copy.vue'),
    meta: { name: '产品表现', keepAlive: true, permission: 'skuAnalyze:view', modal: '分析' }
  },
  // {
  //   name: 'marketAnalysis',
  //   path: '/statistics/market-analysis',
  //   component: () => import('modules/statistics/common/analysis/market/market-analysis-performance'),
  //   meta: { name: '店铺表现', keepAlive: true, permission: 'storeAnalyze:view' ,modal:'分析'}
  // },
  // {
  //   name: 'marketStatistics',
  //   path: '/statistics/market-statistics',
  //   component: () => import('modules/statistics/market-statistics/market-statistics'),
  //   meta: { name: '店铺统计', keepAlive: true, permission: 'storeStatistics:view' ,modal:'分析'}
  // },
  {
    path: '/statistics/storage-long-fee',
    component: () => import('modules/statistics/storage-long-fee/storage-long-fee'),
    meta: { name: '长期仓储费', keepAlive: true, permission: 'longStorageFee:view' ,modal:'分析'}
  },
  {
    path: '/statistics/compensate',
    component: () => import('modules/statistics/compensate/compensate'),
    meta: { name: '赔偿', keepAlive: true, permission: 'reimbursement:view' ,modal:'分析'}
  },
  {
    path: '/statistics/fba-replenishment',
    component: () => import('modules/statistics/fba-replenishment/fba-replenishment'),
    meta: { name: 'FBA补货', keepAlive: true, permission: 'fbaRestock:view' ,modal:'分析'}
  },
  {
    path: '/statistics/inventory-adjustments',
    component: () => import('modules/statistics/inventory-adjustments/inventory-adjustments'),
    meta: { name: '盘库', keepAlive: true, permission: 'inventoryAdjustments:view' ,modal:'分析'}
  },
  {
    path: '/statistics/received-inve',
    component: () => import('modules/statistics/received-inve/received-inve'),
    meta: { name: '已接收库存', keepAlive: true, permission: 'receiptsInventory:view' ,modal:'分析'}
  },
  {
    path: '/statistics/inve-action-details',
    component: () => import('modules/statistics/inve-action-details/inve-action-details'),
    meta: { name: '库存动作详情', keepAlive: true, permission: 'inventoryEventDetail:view' ,modal:'分析'}
  },
  {
    path: '/statistics/asin-361-analysis',
    name: 'statistics-asin-361-analysis',
    component: () => import('modules/statistics/asin-361-analysis/index'),
    meta: { name: 'ASIN看板', keepAlive: false, permission: 'asin361:view' ,modal:'分析'}
  },
  // {
  //   path: '/statistics/profit-statistics',
  //   name: 'profit-statistics',
  //   component: () => import('modules/statistics/profit-statistics/profit-statistics'),
  //   meta: { name: '利润统计', keepAlive: true, permission: 'profitStatistics:view' }
  // },
  {
    path: '/statistics/profit-statistics',
    name: 'profit-statistics',
    component: () => import('modules/statistics/profit-statistics-copy/profit-statistics-copy'),
    meta: { name: '利润统计', keepAlive: true, permission: 'profitStatistics:view', modal: '分析' }
  },
  {
    path: '/statistics/store-performance',
    name: "statistics-store-performance",
    component: () => import('modules/statistics/store-performance/store-performance'),
    meta: { name: '全店铺绩效', keepAlive: true, permission: 'allMarketPerformance:view' ,modal:'分析'}
  },
  {
    path: '/statistics/store-performance-details',
    name: "statistics-store-performance-details",
    component: () => import('modules/statistics/store-performance/store-performance-details/index.vue'),
    meta: { name: '单店铺绩效', keepAlive: true, permission: 'singleMarketPerformance:view' ,modal:'分析'}
  },
  {
    path: '/statistics/business-report',
    name: "business-report",
    component: () => import('@/views/modules/statistics/business-report/business-report.vue'),
    meta: { name: '业务报告', keepAlive: true, permission: 'businessReport:view' ,modal:'分析'}
  },
  {
    path: '/statistics/date-range-report',
    name: "date-range-report",
    component: () => import('@/views/modules/statistics/date-range-report/date-range-report.vue'),
    meta: { name: '日期范围报告', keepAlive: true, permission: 'dateRangeReport:view' ,modal:'分析'}
  }
];
